//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import env from '@tencent/vft-common/env';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';
import SwiperCore, { Autoplay, Pagination } from 'swiper/core';
SwiperCore.use([Autoplay, Pagination]);
export default {
  components: {
    Swiper: Swiper,
    SwiperSlide: SwiperSlide
  },
  data: function data() {
    return {
      isApp: env.isApp,
      index: 0,
      swiperOptions: {
        loop: true,
        direction: 'horizontal',
        autoplay: true,
        speed: 800,
        initialSlide: 2,
        slidesPerView: 'auto',
        centeredSlides: true,
        pagination: {
          el: '.swiper-pagination'
        }
      }
    };
  }
};